/* eslint-disable react/no-unused-state,react/no-unescaped-entities */
import React, { memo, useState } from "react";
import { Card, CardBody, Col, ButtonToolbar } from "reactstrap";
import { Link } from "react-router-dom";
import DataTable from "../../../../shared/components/DataTable";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import "react-confirm-alert/src/react-confirm-alert.css";
import AccessControl from "../../../../shared/components/AccessControl";
import { permissionsConstants } from "../../../../constants/permissions.constants";
import CustomSearch from "./CustomSearch";
import { MdModeEdit, MdInsertDriveFile } from "react-icons/md";
import { string } from "prop-types";

const IssuerDomainMappingTable = memo(
  ({
    dataState,
    fetchData,
    mappings,
    history,
    location,
    permissions,
    getIssuersMappingALL,
  }) => {
    const [searchKey, setSearchKey] = useState("");
    const count =
      dataState && dataState.response ? dataState.response.count : 0;

    const columns = [
      {
        accessor: "issuerName",
        sortKey: "issuer_name",
        name: "Issuer Name",
        sortable: true,
      },
      {
        accessor: "issuerCode",
        sortKey: "issuer_code",
        name: "Issuer Code",
        sortable: true,
      },
      {
        accessor: "domainCode",
        sortKey: "domain_code",
        name: "Domain Code",
        sortable: true,
      },
      {
        accessor: "bankCode",
        sortKey: "bankCode",
        name: "Bank Code",
        sortable: true,
      },
      {
        accessor: "reportPrefix",
        sortKey: "reportPrefix",
        name: "Report Issuer",
        sortable: true,
      },
      {
        accessor: "issuerNr",
        sortKey: "issuerNr",
        name: "Issuer Number",
        sortable: true,
      },
    ];

    const sortFn = (page, pageSize, column) => {
      let sortOrder = "ASC";
      if (!mappings.loading) {
        if (mappings.request && mappings.request.sortOrder) {
          sortOrder = mappings.request.sortOrder === "ASC" ? "DESC" : "ASC";
        }
        fetchData({
          ...mappings.request,
          page,
          pageSize,
          sortKey: column.sortKey,
          sortOrder,
        });
      }
    };

    const handleSubmit = (values) => {
      setSearchKey(values.searchWord);

      fetchData({
        ...mappings.request,
        page: 1,
        searchWord: values.searchWord || "",
      });
    };
    const onSearchBarChange = () => {
      getIssuersMappingALL();
    };

    const loadData = (page, pageSize) => {
      fetchData({ ...mappings.request, page, pageSize, searchWord: searchKey });
    };

    const handleAction = (row, action) => {
      if (action.name === "view_issuerMappings") {
        history.push(`${location.pathname}/view/${row.domainCode}`);
      } else if (action.name === "edit_issuerMappings") {
        let formatParams = {
          domainCode: row.domainCode,
          issuerCode: row.issuerCode,
        };
        // history.push(`${location.pathname}/edit/${row.domainCode}`);
        history.push(
          `${location.pathname}/edit/${row.domainCode}/${row.issuerCode}`
        );
      }
    };

    const actions = [
      {
        name: "view_issuerMappings",
        btnText: "View Mapping",
        btnAction: handleAction,
        btnClass: "success",
        btnIcon: MdInsertDriveFile,
        permissions: [permissionsConstants.VIEW_ISSUER_MAPPINGS],
      },
      {
        name: "edit_issuerMappings",
        btnText: "Edit Mappings",
        btnAction: handleAction,
        btnClass: "default",
        btnIcon: MdModeEdit,
        permissions: [permissionsConstants.VIEW_ISSUER_MAPPINGS],
      },
    ];

    return (
      <Col md={12} lg={12}>
        <Card>
          <CardBody>
            <div className="card__title">
              <h5 className="bold-text">Issuer/Domain Mapping</h5>
              <AccessControl
                allowedPermissions={[
                  permissionsConstants.CREATE_ISSUER_MAPPING,
                ]}
                renderNoAccess={() => null}
              >
                <ButtonToolbar className="products-list__btn-toolbar-top">
                  <Link
                    className="btn btn-primary products-list__btn-add"
                    to="/issuer-mapping/add"
                    id="link-create-mapping"
                  >
                    Create new mapping
                  </Link>
                </ButtonToolbar>
              </AccessControl>
            </div>
            <DataTable
              columns={columns}
              loading={dataState && dataState.loading}
              data={
                dataState && dataState.response
                  ? dataState.response.content
                  : []
              }
              actions={actions}
              count={count}
              permissions={permissions}
              countName="mappings"
              defaultPageSize={10}
              defaultPageNumber={1}
              loadData={loadData}
              error={dataState && dataState.error}
              bordered={true}
              striped={true}
              hover={true}
              customSearch={
                <CustomSearch
                  pageNumer={1}
                  initialValues={{
                    pageNumber: 1,
                    pageSize: 10,
                    searchKey: "",
                  }}
                  pageSize={10}
                  onSubmit={handleSubmit}
                  onSearchBarChange={onSearchBarChange}
                />
              }
              sortFn={sortFn}
              searchKey={searchKey}
              responsive
              serverside
            />
          </CardBody>
        </Card>
      </Col>
    );
  }
);

export default withRouter(
  connect((state) => ({
    mappings: state.getAllIssuerDomainMapping,
    permissions: state.permissions && state.permissions.response,
  }))(IssuerDomainMappingTable)
);
